const inFlightAbortControllers = new Set<AbortController>()

/** Keep AbortControllers reachable across full page unload (React cleanup may not run). */
export function trackInFlightGetAbort(controller: AbortController): () => void {
  inFlightAbortControllers.add(controller)
  return () => {
    inFlightAbortControllers.delete(controller)
  }
}

export function abortAllInFlightGets() {
  inFlightAbortControllers.forEach(controller => {
    if (!controller.signal.aborted) {
      controller.abort()
    }
  })
  inFlightAbortControllers.clear()
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => abortAllInFlightGets())
}
